
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";

import { environment } from "../environments/environment";
import { AuthService } from "./auth.service";
import { Router } from "@angular/router";
import { Rekbot } from "../models/rekbot.model";
import { RekbotSettings } from "../models/rekbot-settings.model";
import { SmtpConfig } from "../models/smtp-config.model";

@Injectable({
    providedIn: 'root'
})

export class SettingsService {

    constructor(
        private http: HttpClient,
        private authService: AuthService,
        private router: Router
    ) {
    }

    fetchSmtp() {
        const endpoint = environment.apiUrl + "/api/settings/smtp";
        if(this.authService.getToken().length == 0) {
            this.router.navigate(['/']);
        }
        const bearerToken = "Bearer " + this.authService.getToken()
        return this.http.get(endpoint, {headers: new HttpHeaders().set("Authorization", bearerToken)})
    }

    updateSmtp(item : SmtpConfig) {

        const endpoint = environment.apiUrl + "/api/settings/smtp/" + item.id  ;

        if(this.authService.getToken().length == 0) {
            this.router.navigate(['/']);
        }
        const bearerToken = "Bearer " + this.authService.getToken()

        return this.http.put(endpoint, item, {headers: new HttpHeaders().set("Authorization", bearerToken)})

    }

    /*fetchRekbotSettings(id: number) {
        const endpoint = environment.apiUrl + "/api/rekbots/" + id + "/settings";
        if(this.authService.getToken().length == 0) {
            this.router.navigate(['/']);
        }
        const bearerToken = "Bearer " + this.authService.getToken()
        return this.http.get(endpoint, {headers: new HttpHeaders().set("Authorization", bearerToken)})
    }*/


    /*updateRekbot( rekbot: Rekbot ) {
        const endpoint = environment.apiUrl + "/api/rekbots/update/" + rekbot.id  ;

        if(this.authService.getToken().length == 0) {
            this.router.navigate(['/']);
        }
        const bearerToken = "Bearer " + this.authService.getToken()

        return this.http.put(endpoint, rekbot, {headers: new HttpHeaders().set("Authorization", bearerToken)})
    }

    updateRekbotSettings( elementId: number, rekbotSetings: RekbotSettings ) {
        const endpoint = environment.apiUrl + "/api/rekbots/" + elementId + "/settings/" + rekbotSetings.id;

        if(this.authService.getToken().length == 0) {
            this.router.navigate(['/']);
        }
        const bearerToken = "Bearer " + this.authService.getToken()

        return this.http.put(endpoint, rekbotSetings, {headers: new HttpHeaders().set("Authorization", bearerToken)})
    }

    createRekbotSettings( elementId: number, rekbotSetings: RekbotSettings ) {
        const endpoint = environment.apiUrl + "/api/rekbots/" + elementId + "/settings";

        if(this.authService.getToken().length == 0) {
            this.router.navigate(['/']);
        }
        const bearerToken = "Bearer " + this.authService.getToken()

        return this.http.post(endpoint, rekbotSetings, {headers: new HttpHeaders().set("Authorization", bearerToken)})
    }

    addRekbot( rekbot: Rekbot  ) {
        const endpoint = environment.apiUrl + "/api/rekbots/add";

        if(this.authService.getToken().length == 0) {
            this.router.navigate(['/']);
        }
        const bearerToken = "Bearer " + this.authService.getToken()

        return this.http.post(endpoint, rekbot, {headers: new HttpHeaders().set("Authorization", bearerToken)})
    }

    deleteRekbot( rekbot: Rekbot  ) {
        const endpoint = environment.apiUrl + "/api/rekbots/delete/" + rekbot.id;

        if(this.authService.getToken().length == 0) {
            this.router.navigate(['/']);
        }
        const bearerToken = "Bearer " + this.authService.getToken()

        return this.http.delete(endpoint, {headers: new HttpHeaders().set("Authorization", bearerToken)})
    }

    restartRekbot( rekbot: Rekbot  ) {
        const endpoint = environment.apiUrl + "/api/rekbots/restart/" + rekbot.id;

        if(this.authService.getToken().length == 0) {
            this.router.navigate(['/']);
        }
        const bearerToken = "Bearer " + this.authService.getToken()

        return this.http.put(endpoint, rekbot, {headers: new HttpHeaders().set("Authorization", bearerToken)})
    }

    downloadLogs( rekbot: Rekbot ) {
        const endpoint = environment.apiUrl + "/api/rekbots/get-log/" + rekbot.serial_no;

        if(this.authService.getToken().length == 0) {
            this.router.navigate(['/']);
        }
        const bearerToken = "Bearer " + this.authService.getToken()
        return this.http.get(endpoint, {headers: new HttpHeaders().set("Authorization", bearerToken)})
    }

    fetchRekbot( id: number ) {
        const endpoint = environment.apiUrl + "/api/rekbots/show/" + id;
        
        if(this.authService.getToken().length == 0) {
            this.router.navigate(['/']);
        }
        const bearerToken = "Bearer " + this.authService.getToken()
        return this.http.get(endpoint, {headers: new HttpHeaders().set("Authorization", bearerToken)})
    }

    fetchLogFromRekbot( rekbot: Rekbot ) {
        const endpoint = environment.apiUrl + "/api/rekbots/get-log/" + rekbot.serial_no;
        
        if(this.authService.getToken().length == 0) {
            this.router.navigate(['/']);
        }
        const bearerToken = "Bearer " + this.authService.getToken()
        return this.http.get(endpoint, {headers: new HttpHeaders().set("Authorization", bearerToken)})
    }

    fetchSettingsFromRekbot( rekbotId: number ) {
        const endpoint = environment.apiUrl + "/api/rekbots/get-config/" + rekbotId;
        
        if(this.authService.getToken().length == 0) {
            this.router.navigate(['/']);
        }
        const bearerToken = "Bearer " + this.authService.getToken()
        return this.http.get(endpoint, {headers: new HttpHeaders().set("Authorization", bearerToken)})
    }*/


    sendSmtpSettingsToRekbot( rekbotId: number,  rekbotSettings: RekbotSettings) {
        const endpoint = environment.apiUrl + "/api/rekbots/put-config/" + rekbotId;
        
        if(this.authService.getToken().length == 0) {
            this.router.navigate(['/']);
        }
        const bearerToken = "Bearer " + this.authService.getToken()

        return this.http.put(endpoint, rekbotSettings, {headers: new HttpHeaders().set("Authorization", bearerToken)})
    }

}